export default __webpack_public_path__ + "static/media/hotService1.7f495bf6.svg";